<template>
  <editResource v-if="editing" :selectedResource="selectedResource" @close="close()"></editResource>
  <v-card width="100%" height="100%" outlined v-else>
    <v-toolbar color="secondary" dark class="title" flat>
      <v-icon left>fas fa-boxes</v-icon>
      Small Group Resources
    </v-toolbar>
    <v-card-text v-if="!confirmDelete">
      <v-row align="center">
        <v-col cols="12" md="8">
          <v-text-field
            v-model="search"
            filled
            clearable
            @click:clear="search = ''"
            label="Search for a Resource"
            color="secondary"
            icon="fas fa-search"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="4" class="body-1 text-right">
          <v-btn outlined class="mb-5" @click="addResource()">
              <v-icon left>fas fa-plus-circle</v-icon>
              Add Resource
          </v-btn>
        </v-col>
      </v-row>
      <v-divider class="pa-3"></v-divider>
      <v-row dense v-for="item in getResources" :key="item.id" class="body-1 rowalt" align="center">
        <v-col cols="12" md="7">
          {{item.title}}
        </v-col>
        <v-col cols="12" md="3" class="text-center">
          {{item.author}}
        </v-col>
        <v-col cols="12" md="2" class="text-right">
          <v-btn icon color="secondary" @click="editResource(item)">
            <v-icon>fas fa-edit</v-icon>
          </v-btn>
          <v-btn icon color="red darken-5" @click="confirmResourceDeletion(item)">
            <v-icon>fas fa-trash</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-text v-if="confirmDelete">
      <v-row>
        <v-col cols="12" class="title text-center">
          Are you sure you want to delete the record for <b>{{ selectedResource.title }}</b>?
        </v-col>
        <v-col cols="6" class="text-center">
          <v-btn outlined color="red darken-5" @click="close()">
            <v-icon left>fas fa-times</v-icon>
            Cancel
          </v-btn>
        </v-col>
        <v-col cols="6" class="text-center" @click="deleteResource()">
          <v-btn outlined color="secondary">
            <v-icon left>fas fa-check</v-icon>
            Confirm
          </v-btn>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import editResource from '@/components/adminComponents/editResource'
export default {
  props: {

  },
  components: {
    editResource
  },
  data(){
    return {
      blankResource : {
        author      : "",
        available   : true,
        description : "",
        format      : {
          audio       : {
            owned : false,
            count : 0
          },
          book        : {
            owned : false,
            count : 0
          },
          dvd         : {
            owned : false,
            count : 0
          },
          leaderGuide : {
            owned : false,
            count : 0
          },
          onlineVideo : {
            owned : false,
            count : 0
          },
          workbook    : {
            owned : false,
            count : 0
          },
          reviews: []
        },
        link        : "", 
        title       : "",
      },
      confirmDelete : false,
      editing       : false,
      search        : "",
      selectedResource  : {}
    }
  },
  methods: {
    addResource(){
      this.selectedResource = this.blankResource
      this.editing          = true
    },
    close(){
      this.confirmDelete    = false
      this.editing          = false
      this.search           = "",
      this.selectedResource = new Object()
    },
    confirmResourceDeletion(resource){
      this.selectedResource = resource
      this.confirmDelete    = true
    },
    deleteResource(){
      this.$store.dispatch('deleteResource', this.selectedResource)
    },
    editResource(resource){
      this.selectedResource = resource
      this.editing          = true
    }
  },
  computed: {
    getResources(){
      if (this.search == ""){
        return this.$store.getters.getResources
      }
      else {
        return this.$store.getters.getResources.filter(item => {
          return item.title.toLowerCase().includes(this.search.toLowerCase())
        })
      }
    }
  }
}
</script>

